import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SERVICES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};
const item = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.21, 0.61, 0.35, 1] } },
};

export const ServicesGrid = () => {
  return (
    <section id="services" className="py-[var(--section-py)]" data-testid="services-section">
      <div className="mx-auto max-w-[var(--container-max)] px-4 sm:px-6">
        {/* Section header */}
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[color:var(--gs-gold-400)]">
            What We Do
          </p>
          <h2 className="font-display mt-3 text-3xl font-bold text-white sm:text-4xl" data-testid="services-heading">
            Our Services
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-white/60">
            Ten specialized services, one accountable partner. Click any service to
            learn more about how we deliver it.
          </p>
        </div>

        {/* Services grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3"
        >
          {SERVICES.map((service) => (
            <motion.div key={service.name} variants={item}>
              <Link
                to={`/${service.slug}`}
                data-testid="service-card"
                aria-label={`Learn more about ${service.name}`}
                className="service-card-hover group relative block min-h-[168px] rounded-[var(--radius)] border border-white/10 bg-[color:var(--gs-glass)] p-6 text-left backdrop-blur hover:border-[color:var(--gs-line)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--gs-gold-400)]"
              >
                <div className="flex items-start justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-[color:var(--gs-line)] bg-[rgba(240,180,41,0.1)] text-[color:var(--gs-gold-400)] group-hover:bg-[rgba(240,180,41,0.18)]">
                    <service.icon className="h-5 w-5" />
                  </div>
                  <ArrowUpRight className="h-4 w-4 text-white/20 group-hover:text-[color:var(--gs-gold-400)]" />
                </div>
                <h3 className="font-display mt-4 text-lg font-semibold text-white group-hover:text-[color:var(--gs-gold-400)]">
                  {service.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60">
                  {service.description}
                </p>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
